import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MergeTypeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"merge_type"}/>
}
